var getModel = (items, key, id) => {
	for (let item of items) {
		if (item[key] == id) {
			return item;
		}
	}
};

export { getModel };
